import { useContext } from 'react'
import { PageRouterContext } from 'shared/providers/PageRouterProvider/PageRouterProvider'

const usePageRouter = () => {
  const context = useContext(PageRouterContext)
  return context
}

export default usePageRouter
